<template>
  <ul class="sidebar-menu">
    <li class="header">MENU</li>
    <router-link tag="li" class="pageLink" to="/" :class="[$route.fullPath.indexOf('dashboard') > -1 ? 'active' : '']">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page">Dashboard</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/worldmap" :class="[$route.fullPath.indexOf('worldmap') > -1 ? 'active' : '']">
      <a>
        <i class="fa fa-globe"></i>
        <span class="page">Worldmap</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/testimonies" :class="[$route.fullPath.indexOf('testimonies') > -1 ? 'active' : '']">
      <a>
        <i class="fa fa-book"></i>
        <span class="page">Testimonies</span>
      </a>
    </router-link>
    
    <router-link tag="li" class="pageLink" to="/cases" :class="[$route.fullPath.indexOf('cases') > -1 ? 'active' : '']">
      <a>
        <i class="fa fa-folder"></i>
        <span class="page">Cases</span>
      </a>
    </router-link>

    <router-link v-if="role === 'WWOW_ADMIN'" tag="li" class="pageLink" to="/users" :class="[$route.fullPath.indexOf('users') > -1 ? 'active' : '']">
      <a>
        <i class="fa fa-users"></i>
        <span class="page">Users</span>
      </a>
    </router-link>

    <router-link tag="li" class="pageLink" to="/subscriptions" :class="[$route.fullPath.indexOf('subscriptions') > -1 ? 'active' : '']">
      <a>
        <i class="fa fa-bell"></i>
        <span class="page">Subscriptions</span>
      </a>
    </router-link>
  </ul>
</template>
<script>
export default {
  name: 'SidebarName',
  props: ['role']
}
</script>
<style>
  /* override default */
  .sidebar-menu>li>a {
    padding: 12px 15px 12px 15px;
  }

  .sidebar-menu li.active>a>.fa-angle-left, .sidebar-menu li.active>a>.pull-right-container>.fa-angle-left {
    animation-name: rotate;
    animation-duration: .2s;
    animation-fill-mode: forwards;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(-90deg);
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?4d6a168f